import Collapse from 'antd/lib/collapse'
import styled from '@emotion/styled'

const { Panel } = Collapse

export const StyledCollapse = styled(Collapse)`
  .ant-collapse-header {
    padding-right: 16px !important;
  }
  &.ant-collapse-icon-position-end
    > .ant-collapse-item
    > .ant-collapse-header
    .ant-collapse-arrow {
    right: 0;
  }
`

export const StyledPanel = styled(Panel)`
  .ant-collapse-header-text {
    width: 100%;
  }
`
